
import * as React from "react";
import { Lng } from "../../../languages/Languages";

interface IFilterFormProps {
    changed:IChanged
}

interface IChanged{
    (str:string):void
}


interface IFilterFormState {
    filter:string
}

export default class FilterForm extends React.Component<IFilterFormProps, IFilterFormState>{

  	constructor(props:IFilterFormProps){
        super(props);
        this.state = {
            filter: ''
        };
    }

    private changedFilterInputHandler(evt): void {
        evt.preventDefault();
        this.setState({
            filter: evt.target.value
        });
    }

    private submitHandler(evt): void {
        evt.preventDefault();
        this.props.changed(this.state.filter)
    }


    render() {
        return (
            <form onSubmit={ e => this.submitHandler(e) } className="form" id="header_filter_form" >
                <div className="form-group has-feedback has-search">
                    <input type="text" required={true} className="s-form-control" id="header_filter_text" placeholder={Lng.get('search')} value={ this.state.filter } onChange={ (e) => this.changedFilterInputHandler(e) } />
                </div>
			</form>
        );
    }
}
